import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import * as Repository from "../repository";
import { MarketingVoucherEditNewPresenter } from "./presenter";

type Props = {
	hotelID: string;
	duplicateItemID: string | undefined;
};

export const MarketingVoucherEditNewContainer = ({ hotelID, duplicateItemID }: Props) => {
	const queryData = Repository.Query.UseCase.useVoucherNewItem({ hotelID, duplicateItemID });

	if (!queryData) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <MarketingVoucherEditNewPresenter hotelID={hotelID} queryData={queryData} />;
};

MarketingVoucherEditNewContainer.displayName = "MarketingVoucherEditNewContainer";
